import React from "react";
import { CONTINUE_LEARNING } from "../../utils/dashboardConstant";
import { IMAGES } from "../../utils/images";

const DashboardRecordedClasses = () => {
  return (
    <div className="dashboard-content">
      <div className="home-heading-container">
        <h1 className="heading-text-h1">Recording Sessions</h1>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="rec-container">
        <h1 className="recording-heading">Topic 1</h1>
        <div className="video-cards-container">
          {CONTINUE_LEARNING.map((course) => {
            console.log(course.backgroundimage);
            return (
              <div className="video-container" key={course.id}>
                <div className="video-card">
                  <IMAGES.RECORDED_ICON className="play-icon" />
                  <img
                    src={course.backgroundimage}
                    className="background-image"
                  />
                </div>
                <p className="video-card-content">{course.title}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="rec-container">
        <h1 className="recording-heading">Topic 2</h1>
        <div className="video-cards-container">
          {CONTINUE_LEARNING.map((course) => {
            console.log(course.backgroundimage);
            return (
              <div className="video-container" key={course.id}>
                <div className="video-card">
                  <IMAGES.RECORDED_ICON className="play-icon" />
                  <img
                    src={course.backgroundimage}
                    className="background-image"
                  />
                </div>
                <p className="video-card-content">{course.title}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="rec-container">
        <h1 className="recording-heading">Topic 3</h1>
        <div className="video-cards-container">
          {CONTINUE_LEARNING.map((course) => {
            console.log(course.backgroundimage);
            return (
              <div className="video-container" key={course.id}>
                <div className="video-card">
                  <IMAGES.RECORDED_ICON className="play-icon" />
                  <img
                    src={course.backgroundimage}
                    className="background-image"
                  />
                </div>
                <p className="video-card-content">{course.title}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DashboardRecordedClasses;
